"use strict";

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFlag = exports.getFlag = exports.setFlag = exports.LOCAL_STORAGE_FLAG_PREFIX = void 0;

var react_1 = __importDefault(require("react"));

var log_1 = require("../log");

var storage_1 = require("./storage");

exports.LOCAL_STORAGE_FLAG_PREFIX = 'feature-react-flags';

function getFlagKey(key) {
  return [exports.LOCAL_STORAGE_FLAG_PREFIX, key].join('-');
}

function setFlag(flag, value) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(value === null)) {
              _context.next = 5;
              break;
            }

            _context.next = 3;
            return (0, storage_1.deleteItem)(getFlagKey(flag));

          case 3:
            _context.next = 7;
            break;

          case 5:
            _context.next = 7;
            return (0, storage_1.storeItem)(getFlagKey(flag), value);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.setFlag = setFlag;

function getFlag(flag) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", (0, storage_1.getItem)(getFlagKey(flag)));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.getFlag = getFlag;

function useFlag(name, defaultValue) {
  var _react_1$default$useS = react_1.default.useState(defaultValue),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      flagValue = _react_1$default$useS2[0],
      _setFlagValue = _react_1$default$useS2[1];

  react_1.default.useEffect(function () {
    getFlag(name).then(function (val) {
      _setFlagValue(val === null ? defaultValue : val);
    });
  }, [name]);
  return [flagValue, function (newValue) {
    _setFlagValue(function (existing) {
      var n = typeof newValue === 'function' ? newValue(existing) : newValue;
      setFlag(name, n).catch(function (err) {
        (0, log_1.warn)('error setting flag %s to %O', name, newValue);
        (0, log_1.warn)(err);
      });
      return n;
    });
  }];
}

exports.useFlag = useFlag;